module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/a95d21c632f7eeb5900578919918ddc8.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/badges/Bronze/Bronze0.svg
// module id = Op+y
// module chunks = 1